<nb-card class="form">
  <nb-card-header>
    <h4>{{ "dialogs.courseEdit.title" | translate }}: {{ courseName }}</h4>
  </nb-card-header>

  <nb-card-body>
    <div *ngIf="loading" class="loading-state">
      <nb-spinner status="primary" size="medium"></nb-spinner>
    </div>

    <div *ngIf="!loading" class="edit-form">
      <!-- Description -->
      <div class="form-group">
        <label>{{ "dialogs.courseEdit.description" | translate }}</label>
        <textarea
          nbInput
          fullWidth
          [(ngModel)]="description"
          rows="3"
          [placeholder]="'dialogs.courseEdit.descriptionPlaceholder' | translate"
        ></textarea>
      </div>

      <!-- Metadata / Additional Context -->
      <div class="form-group">
        <label>{{ "dialogs.courseEdit.metadataContext" | translate }}</label>
        <textarea
          nbInput
          fullWidth
          [(ngModel)]="metadataContext"
          rows="3"
          [placeholder]="'dialogs.courseEdit.metadataContextPlaceholder' | translate"
        ></textarea>
        <span class="hint">{{ "dialogs.courseEdit.metadataContextHint" | translate }}</span>
      </div>

      <!-- Learning Goals -->
      <div class="form-group">
        <label>{{ "dialogs.courseEdit.learningGoals" | translate }}</label>
        <textarea
          nbInput
          fullWidth
          [(ngModel)]="learningGoals"
          rows="3"
          [placeholder]="'dialogs.courseEdit.learningGoalsPlaceholder' | translate"
        ></textarea>
      </div>

      <!-- Difficulty Level -->
      <div class="form-group">
        <label>{{ "dialogs.courseEdit.difficultyLevel" | translate }}</label>
        <nb-select [(selected)]="difficultyLevel" fullWidth [placeholder]="'dialogs.courseEdit.difficultyPlaceholder' | translate">
          <nb-option value="">{{ "dialogs.courseEdit.difficultyNone" | translate }}</nb-option>
          <nb-option value="EASY">{{ "dialogs.courseEdit.difficultyEasy" | translate }}</nb-option>
          <nb-option value="MEDIUM">{{ "dialogs.courseEdit.difficultyMedium" | translate }}</nb-option>
          <nb-option value="HARD">{{ "dialogs.courseEdit.difficultyHard" | translate }}</nb-option>
        </nb-select>
      </div>

      <!-- Sync Frequency -->
      <div class="form-group">
        <label>{{ "dialogs.courseEdit.syncFrequency" | translate }}</label>
        <nb-select [(selected)]="syncFrequency" fullWidth>
          <nb-option value="NEVER">{{ "dialogs.courseEdit.freqNever" | translate }}</nb-option>
          <nb-option value="DAILY">{{ "dialogs.courseEdit.freqDaily" | translate }}</nb-option>
          <nb-option value="MONTHLY">{{ "dialogs.courseEdit.freqMonthly" | translate }}</nb-option>
          <nb-option value="YEARLY">{{ "dialogs.courseEdit.freqYearly" | translate }}</nb-option>
        </nb-select>
      </div>

      <!-- Participant Sync Frequency -->
      <div class="form-group">
        <label>{{ "dialogs.courseEdit.participantSyncFrequency" | translate }}</label>
        <nb-select [(selected)]="participantSyncFrequency" fullWidth>
          <nb-option value="NEVER">{{ "dialogs.courseEdit.freqNever" | translate }}</nb-option>
          <nb-option value="MONTHLY">{{ "dialogs.courseEdit.freqMonthly" | translate }}</nb-option>
          <nb-option value="YEARLY">{{ "dialogs.courseEdit.freqYearly" | translate }}</nb-option>
        </nb-select>
        <span class="hint">{{ "dialogs.courseEdit.participantSyncHint" | translate }}</span>
      </div>

      <!-- Dependencies -->
      <div class="form-group">
        <label>{{ "dialogs.courseEdit.dependencies" | translate }}</label>
        <nb-select
          [(selected)]="selectedDependencies"
          multiple
          fullWidth
          [placeholder]="'dialogs.courseEdit.dependenciesPlaceholder' | translate"
        >
          <nb-option *ngFor="let course of allCourses" [value]="course.id">
            {{ course.course_name }}
          </nb-option>
        </nb-select>
        <span class="hint">{{ "dialogs.courseEdit.dependenciesHint" | translate }}</span>
      </div>
    </div>
  </nb-card-body>

  <nb-card-footer>
    <button nbButton status="danger" outline (click)="close()">
      {{ "buttons.close" | translate }}
    </button>
    <button
      nbButton
      status="primary"
      [disabled]="saving || loading"
      [nbSpinner]="saving"
      (click)="save()"
    >
      {{ "buttons.save" | translate }}
    </button>
  </nb-card-footer>
</nb-card>
